import { StyleSheet } from 'react-native'
import { View } from 'react-native'
import { ActionHint } from '@ppwr/poker'
import { RaiseOrFold } from './RaiseOrFold'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../models'
import { DealTheFlop } from './DealTheFlop'

interface PlayerHandWalkthroughProps {
  onPlayerAction: (action: ActionHint) => void
  gap: number
}

export const PlayerHandWalkthrough = observer(({ onPlayerAction, gap }: PlayerHandWalkthroughProps) => {
  const {
    game: { walkthroughType }
  } = useStore()

  const Content =
    walkthroughType === 'RaiseOrFold' ? (
      <RaiseOrFold onPlayerAction={onPlayerAction} />
    ) : (
      <DealTheFlop onPlayerAction={onPlayerAction} />
    )

  return <View style={[styles.container, { gap }]}>{Content}</View>
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'space-between',
    paddingHorizontal: 5
  }
})
